// extracted by mini-css-extract-plugin
module.exports = {"Skeleton":"Skeleton_Skeleton__2iyAa","shimmer":"Skeleton_shimmer__1t4_O"};